import React from "react";

const SpreadsheetContext = React.createContext({});

export default SpreadsheetContext;